'use strict';

var angular = require('angular');
var WhatIfPopoverDirective = function WhatIfPopoverDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/what-if-popover.html'),
    controller: 'WhatIfPopoverController',
    scope: {
      rule: '=',
      whatIfStatus: '=',
      isSubmitDisabled: '='
    },
    link: function link($scope) {
      $scope.popoverClicked = function (e) {
        e.stopPropagation();
        if (angular.element(e.target).hasClass('cancel-drop-down')) {
          angular.element('.toolbar-dropdown-menu').parent().removeClass('open');
        }
      };
      $scope.$watch('rule', $scope.initScope);
    }
  };
};
WhatIfPopoverDirective.$inject = [];
module.exports = WhatIfPopoverDirective;